<template>
  <div class="canvasCircleBody">
    <div class="circleBox" :style="getBackgroudImageStyle">
      <svg class="ring-container" style="width:80px;height: 80px;">
        <circle :cx="cx" :cy="cx" :r="r" :stroke="backgroundColor" :stroke-width="width" stroke-linecap="round"
          fill="transparent"></circle>
        <circle :cx="cx" :cy="cx" :r="r" class="ring" :stroke-width="width" :stroke="rate == 0 ? 'transparent': color"
          :style="`stroke-dasharray: ${arc} ${per}`" stroke-linecap="round" fill="transparent"></circle>
      </svg>
      <span class="aa" style="position: absolute;bottom: 36%;">{{rate}}%</span>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
	export default {
		computed: {
			cx() { // 中心点位置
				return this.size / 2
			},
			r() { // 半径
				return this.size / 2 - this.width
			},
			per() { // 周长
				return parseInt(this.r * Math.PI * 2)
			},
			arc() { // 弧长
				return parseInt(this.per * (this.rate === 0 ? 0 : this.rate / 100))
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			getBackgroudImageStyle() {
				return {
					'background': 'url(' + this.getResourcesByName('unitInfo/circle_bg.png') + ') no-repeat 50% 50%',
					'background-size': 'auto 100%',
				}
			}
		},
		props: {
			fontSize: {
				type: Number,
				default: 80,
				color: 'red'
			},
			size: {
				type: Number,
				default: 80
			},
			width: {
				type: Number,
				default: 5
			},
			rate: {
				type: [Number, String],
				default: 0
			},
			color: {
				type: String,
				default: ""
			},
			backgroundColor: {
				type: String,
				default: "#FFFFFF"
			},
			pvalue: {
				type: [Number, String],
			},
			pcontent: {
				type: String,
			},
		},
		mounted() {
		}
	}
</script>

<style scoped>
  .aa {
    color: #fff;
    font-weight: bold;
    font-size: 18px;

  }

  .value {
    width: 100%;
    line-height: 25px;
  }

  .content {
    width: 100%;
  }

  .circleBox {
    position: relative;
    width: 100%;
    height: 60%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ring-container .ring {
    transform: rotate(-89deg);
    transform-origin: 50% 50%;
    transition: all 1s;
  }

  .canvasCircleBody {
    text-align: center;
    color: #FFF;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }
</style>